import { render } from "./VuexPostalCodeFormItem.vue?vue&type=template&id=3aee3b3c"
import script from "./VuexPostalCodeFormItem.vue?vue&type=script&lang=js"
export * from "./VuexPostalCodeFormItem.vue?vue&type=script&lang=js"
script.render = render

export default script